import { createContext, useContext } from "react";

/** The tab ids a chat surface navigates to, from the Reports tab set. */
export type ChatTabId = "chat" | "reports";

interface ChatTabsContextValue {
  showTab: (tab: ChatTabId) => void;
}

const ChatTabsContext = createContext<ChatTabsContextValue>({
  showTab: () => {}
});

/**
 * Lets a message deep inside the chat list switch the drawer's tab, which the
 * list owns. Outside the list — a report previewed on its own — there is no
 * tab to switch, so the default does nothing.
 */
export const ChatTabsProvider = ChatTabsContext.Provider;

export const useChatTabs = () => useContext(ChatTabsContext);
